<template>
  <div class="map" :class="getMapClass">
    <div
      class="banner"
      :class="getTextColor"
      @click="$emit('changeSection', name)"
    >
      <div class="name">{{ name }}</div>
      <div class="num">{{ mcqs.totalSaved }}/{{ mcqs.total }}</div>
    </div>
    <div v-if="selected" class="mapField">
      <div
        v-for="item in mcqs.questions"
        :key="item.number"
        class="cir"
        @click="$emit('changeCurrent', item.number - 1)"
      >
        <CircleComponent
          :id="item.number"
          :current-class="
            mcqs.current === item.number - 1
              ? 'currentDot' + ' ' + item.currentClass + 'Dot'
              : item.currentClass + 'Dot'
          "
        ></CircleComponent>
      </div>
    </div>
  </div>
</template>

<script>
import CircleComponent from './Circle'
export default {
  name: 'Map',
  components: { CircleComponent },
  props: ['mcqs', 'name', 'selected'],
  computed: {
    getMapClass: function() {
      if (this.selected) {
        return 'activeMap'
      } else {
        return 'notActiveMap'
      }
    },
    getTextColor: function() {
      if (this.selected) {
        return 'activeTextColor'
      } else {
        return 'notActiveTextColor'
      }
    },
  },
}
</script>

<style scoped>
.cir {
  cursor: pointer;
  font-family: Roboto-Medium;
  margin-right: 8px;
  margin-bottom: 8px;
  color: #909191;
  width: 27px;
}
.mapField {
  flex-wrap: wrap;
  margin-left: 27px;
  display: flex;
  flex-direction: row;
  margin-bottom: 7px;
}
.map {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.activeMap {
  background: rgba(9, 136, 244, 0.1);
  box-shadow: inset 4px 0 0 0 #0988f4;
}
.banner {
  cursor: pointer;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  font-family: Roboto-Medium;
  font-size: 14px;
  letter-spacing: 0;
  margin-bottom: 13px;
}
.activeTextColor {
  color: #0988f4;
}
.notActiveTextColor {
  color: #909191;
}
.name {
  margin-left: 27px;
  margin-top: 10px;
}
.num {
  display: flex;
  align-self: flex-end;
  margin-right: 14px;
  margin-top: 10px;
}
</style>
